import React, { createContext, useContext, useState } from "react";
import { RequestWizard } from "@/components/site/RequestWizard";

const WizardCtx = createContext(null);

export const WizardProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <WizardCtx.Provider value={{ open, openWizard: () => setOpen(true), setOpen }}>
      {children}
      <RequestWizard open={open} onOpenChange={setOpen} />
    </WizardCtx.Provider>
  );
};

export const useWizard = () => useContext(WizardCtx) || { openWizard: () => {} };
